// API client for the admin Assessment reports (/api/assessment/admin/reports).
//
// GET /reports -> { avgScorePercentage, totalAttempts, completionRate,
//   trend[{ periodStart (yyyy-MM-dd), attemptCount, avgScorePercentage }],
//   breakdownBy ("COURSE" when no course filter, "SUBJECT" when a course is
//   selected), pieSlices[{ label, attemptCount, percentage }],
//   totalRevenue (rupees), revenueByCourse[{ label, amount, percentage }] | null }.
// The trend bucket size adapts to the window: <=31 days daily, <=180 days
// weekly, otherwise monthly. When no window is sent the backend defaults to
// the last 6 months. startDate/endDate are ISO date-times and the window is
// half-open [startDate, endDate).
// GET /reports/export (same params) -> CSV file.
import api from "../axiosInstance";

export { apiErrorMessage } from "./assessmentHierarchy";

const BASE = "/api/assessment/admin/reports";

const cleanParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ""),
  );

// params: courseId, subjectId, testId, startDate, endDate
export const getReports = (params) =>
  api.get(BASE, { params: cleanParams(params) }).then((res) => res.data?.data);

// Downloads the CSV through axios (so the auth header is sent) and triggers a
// browser save using the server's file name when it provides one.
export const downloadReportsCsv = async (params) => {
  const res = await api.get(`${BASE}/export`, {
    params: cleanParams(params),
    responseType: "blob",
  });
  const disposition = res.headers?.["content-disposition"] || "";
  const match = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(disposition);
  const filename = match ? decodeURIComponent(match[1]) : `assessment-reports-${new Date().toISOString().slice(0, 10)}.csv`;

  const url = window.URL.createObjectURL(new Blob([res.data], { type: "text/csv" }));
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
  return filename;
};
